const headRowsGroup = {
  actions: 'Acciones',
  name: 'Grupo'
};

export default headRowsGroup;
